module.exports = __webpack_public_path__ + "img/vipp.47f0882c.png";